import { trackEvent } from "@/remote/tracking";

const apiUrl = (path: string) =>
  `${process.env.GATSBY_KOLOSSAL_API_BASE}/${path.startsWith("/") ? path.substring(1) : path}`;

const fetchApi = (input: string, init?: RequestInit): Promise<Response> =>
  fetch(apiUrl(input), init);

export const sendMessage = (message: string) => {
  trackEvent("Nachricht gesendet");

  return fetchApi("/messages", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      message,
    }),
  });
};

export const readMessage = () =>
  fetchApi("/messages")
    .then((response) => response.json())
    .then((data: DataResponse<Message>) => data.data);

export const getStaff = () =>
  fetchApi("/staff")
    .then((response) => response.json())
    .then((data: ListResponse<StaffMember>) => data.data);
